module.exports = __webpack_public_path__ + "static/media/ci-horizontal.9f8f7b52.png";